import { WaterlilyClient } from '@/api/waterlily';
import { ClientIllustrationsResponse } from '@/features/shop-insurance/types';

export const clientIllustrationsApi = {
  getIllustrations: (clientId: string) =>
    WaterlilyClient.get<ClientIllustrationsResponse>(`/client/${clientId}/illustrations`),
};
